<template>
  <v-card class="vuetify-avatar-selector" tile>
    <v-card-media height="200px">
      <v-layout row align-center justify-center>
        <v-flex
          xs12
          sm12
          md12
          text-xs-center
          layout
          align-center
          justify-center
        >
          <v-avatar
            v-if="item.show_only || false"
            class="avatar-image"
            size="150px"
          >
              <img
                :class="item.show_only ? '' : 'avatar-cursor'"
                :src="item.src ? item.src : ''"
                alt=""
              >
          </v-avatar>
          <v-tooltip bottom v-else>
            <v-avatar
              class="avatar-image"
              size="150px"
              slot="activator"
              @click="changeAvatar()"
            >
                <img
                  :src="item.src ? item.src : ''"
                  alt=""
                >
            </v-avatar>
            <span>Pulsa para cambiar</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <input @change="checkFile('image/png', 200000, 180, 180)" ref="input" type="file" id="avatar" class="input-file" accept="image/x-png, image/jpeg">
    </v-card-media>

    <v-card-title>
      <slot name="card-title"></slot>
    </v-card-title>
    <v-card-text>
      <slot name="card-text"></slot>
    </v-card-text>

    <v-dialog v-model="item.dialog" max-width="350px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Cambiar imagen</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row align-center justify-center>
          <v-avatar
            class="avatar avatar-content"
            size="250px"
          >
            <v-carousel
              :cycle="false"
              hide-delimiters
              :hide-controls="!controls"
              v-model="value"
              lazy
            >
              <v-carousel-item
                v-for="(item, i) in items"
                :key="i"
                :src="item.src"
                ref="carousel"
                transition="fade"
                reverse-transition="fade"
              ></v-carousel-item>
            </v-carousel>
          </v-avatar>
        </v-layout>
        <v-card-actions>
          <v-layout class="carousel-actions" row align-center justify-center>
            <v-tooltip top>
              <v-btn slot="activator" outline fab color="primary" @click="selectAvatarFile()">
                <v-icon>file_upload</v-icon>
              </v-btn>
              <span>Subir imagen de 180 x 180 píxeles en formato PNG</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn slot="activator" outline fab color="primary" @click="saveAvatar()">
                <v-icon>check</v-icon>
              </v-btn>
              <span>Utilizar el seleccionado</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn slot="activator" outline fab color="primary" @click="item.dialog = false">
                <v-icon>exit_to_app</v-icon>
              </v-btn>
              <span>Salir</span>
            </v-tooltip>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  'use strict'

  export default {

    name: 'VuetifyAvatarSelector',

    props: {
      avatar: {
        type: Object,
        default: null,
        required: true
      },
      avatars: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      controls: {
        type: Boolean,
        default: true,
        required: false
      }
    },

    data: () => ({
      item: {},
      items: [],
      dialog: false,
      value: 0
    }),

    mounted () {
      this.item = this.avatar
      this.items = this.avatars
    },

    watch: {
      avatars: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },
      avatar: {
        handler: function (newVal, oldVal) {
          this.item = newVal
          if (this.$refs.carousel && this.$refs.carousel[this.value]) {
            this.$refs.carousel[this.value].$data.active = true
          }
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      selectAvatarFile () {
        this.$refs.input.value = ''
        this.$refs.input.click()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      changeAvatar () {
        console.log('ssss')
        this.item.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      checkFile (format, maxFileSize, width, height) {
        let file = this.$refs.input.files[0]
        let reader = new FileReader()
        reader.readAsDataURL(file)

        let self = this
        reader.addEventListener('load', function () {
          let img = new Image()

          img.onload = () => {
            if (file.type !== format) {
              self.$emit('on-upload-error', 'format', format)
            } else if (file.size > maxFileSize) {
              self.$emit('on-upload-error', 'max-file-size', maxFileSize)
            } else if (img.width !== width) {
              self.$emit('on-upload-error', 'width', width)
            } else if (img.height !== height) {
              self.$emit('on-upload-error', 'height', height)
            } else {
              self.saveAvatar(reader.result)
            }
          }
          img.src = reader.result
        }, false)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      saveAvatar (data) {
        if (!data) {
          data = this.items[this.value].src
        }
        this.item.src = data
        this.item.dialog = false
        this.$emit('on-change-avatar', this.item)
        this.$forceUpdate()
      }
    }
  }
</script>

<style lang="sass">
.vuetify-avatar-selector
  margin-bottom: 20px

.avatar-image
  margin-top: 29px

.avatar-cursor
  cursor: pointer

.avatar-content
  margin-top: 25px
</style>


// WEBPACK FOOTER //
// src/components/vuetify-avatar-card.vue